import { TabPanel, Tabs } from '@/components';
import { useGetHomeDetailsQuery } from '@/redux';
import { useTranslation } from 'react-i18next';
import {
  HomeDetailsTabKeys,
  PersonalizationSummaryOverviewTabContent,
  PersonalizationTabContent,
  useCommunityContext,
} from '@/views';
import { CommunityPermissions } from '@/core';
import { HomeAttachmentsTabContent } from '../Homes.Details/HomeAttachmentsTabContent';

interface Props {
  title: React.ReactNode;
  projectId: string;
  homeId: string;
}

const { TabPane } = Tabs;

export function ProjectHomePersonalizationTabsPanel(props: Props) {
  const { homeId } = props;
  const { t } = useTranslation();
  const { data, isFetching } = useGetHomeDetailsQuery({ id: homeId });
  const { hasPermission } = useCommunityContext();

  if (!data || isFetching) {
    return null;
  }

  const hasAnyHistory = data.personalizationHistory.length > 0;

  return (
    <Tabs tabKeys={HomeDetailsTabKeys} destroyInactiveTabPane>
      {hasAnyHistory &&
        hasPermission(CommunityPermissions.Personalization.View) && (
          <TabPane
            tab={t('homes.details.tabs.personalization')}
            key={HomeDetailsTabKeys.personalization}
          >
            <PersonalizationTabContent
              personalizationHistory={data.personalizationHistory}
              homeId={homeId}
              communityId={data.communityId}
              isHomeDetails={false}
            />
          </TabPane>
        )}

      {hasAnyHistory && (
        <TabPane
          tab={t('homes.details.tabs.personalizationSummary')}
          key={HomeDetailsTabKeys.personalizationSummary}
        >
          <PersonalizationSummaryOverviewTabContent
            personalizationHistory={data.personalizationHistory}
            homeId={homeId}
            communityId={data.communityId}
          />
        </TabPane>
      )}

      {hasAnyHistory && hasPermission(CommunityPermissions.HomeDocuments.View) && (
        <TabPane
          tab={t('homes.details.tabs.documents')}
          key={HomeDetailsTabKeys.documents}
        >
          <TabPanel>
            <TabPanel.Body>
              <HomeAttachmentsTabContent
                key={homeId}
                id={homeId}
                floorplanId={data.floorplan?.id}
                communityId={data.communityId}
                projectId={data.projectId}
                type="card"
              />
            </TabPanel.Body>
          </TabPanel>
        </TabPane>
      )}
    </Tabs>
  );
}
